import { IInteractionsCount } from "@edgetier/watchtower-types";
import {
    addMinutes,
    differenceInMilliseconds,
    differenceInMinutes,
    getMinutes,
    startOfMinute,
    subMinutes,
} from "date-fns";

const MINUTES_INTERVAL = 90;

/**
 * Get the start and end date times for the next request. The last minute is not request because, due to a delay in how
 * the backend receives data, it will never be populated properly.
 * @returns Start and end date time.
 */
export const getDateTimes = () => {
    return {
        endDateTime: subMinutes(startOfMinute(new Date()), 1),
        startDateTime: startOfMinute(subMinutes(new Date(), MINUTES_INTERVAL)),
    };
};

/**
 * Figure out how long to wait before the start of the next minute. The data is requested every minute on the minute.
 * @returns Milliseconds.
 */
export const getMillisecondsUntilNextPoll = () => {
    return differenceInMilliseconds(startOfMinute(addMinutes(new Date(), 1)), new Date());
};

/**
 * Create the ticks that will be used on the X axis. Times are shown in 15 minute increments.
 * @param chartData The data being displayed in the charts.
 * @returns An array of times that will be displayed on the chart's X axis.
 */
export const createXAxisTicks = (chartData: IInteractionsCount<Date>[]) => {
    const ticks = (chartData ?? [])
        .map((chartData) => chartData.group.getTime())
        .reduce<number[]>((times, time) => {
            // If the first tick has been set, the rest of the ticks should go up in 15 minute increments.
            if (typeof times[0] === "number") {
                const differenceFromStart = differenceInMinutes(times[0], time);
                if (differenceFromStart % 15 === 0) return [...times, time];

                return times;
            }

            // If the first tick has not been set, take any multiple of 5 as the first tick.
            if (getMinutes(time) % 5 === 0) return [...times, time];

            return times;
        }, []);
    return ticks;
};
